<script>

export default {
  data () {
    return {
      paginaInicial: 1,
      paginaFinal: 1,
      paginas: []
    }
  },
  props: {
    setPage: {
      type: Function,
      required: true
    },
    countPage: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      required: true
    }
  },
  methods: {
    montaPaginacao: function () {
      if (this.countPage > 4 && this.page >= 4) {
        this.paginaInicial = this.page - 3
      } else {
        this.paginaInicial = 1
      }
      if (this.page <= 4) {
        if (this.countPage > 7) {
          this.paginaFinal = 7
        } else {
          this.paginaFinal = this.countPage
        }
      } else {
        if ((this.countPage - this.page) >= 3) {
          this.paginaFinal = this.page + 3
        } else {
          this.paginaFinal = this.countPage
          if (this.page === this.countPage) {
            let paginaF = this.page - 6
            if (paginaF > 0) this.paginaInicial = paginaF
            else this.paginaInicial = 1
          } else if ((this.countPage - this.page) <= 4) {
            let paginaI = this.page - (5 - (this.countPage - this.page))
            this.paginaInicial = paginaI
          }
        }
      }
      this.paginas = []
      for (let f = this.paginaInicial; f <= this.paginaFinal; f++) {
        this.paginas.push(f)
      }
    }
  },
  watch: {
    page: function () {
      this.montaPaginacao()
    },
    countPage: function () {
      this.montaPaginacao()
    }
  },
  mounted () {
    this.montaPaginacao()
  }
}
</script>
<template>
<div class="col-lg-12 contemPagination">
  <ul class="pagination paginate-links lista" v-show="countPage > 0">
    <li class="left-arrow seta-inicial" :class="{'disabled': page===1}">
      <a @click="setPage(1)"><i class="fa fa-angle-double-left"></i></a>
    </li>
    <li class="left-arrow seta" :class="{'disabled': page===1}">
      <a @click="setPage(page - 1)"><i class="fa fa-angle-left"></i></a>
    </li>
    <li class="number" :class="{'active': i === page}" v-for="i in paginas" :key="i">
      <a class="ativado" @click="setPage(i)">{{ i }}</a>
    </li>
    <li class="right-arrow seta" :class="{'disabled': page === countPage}">
      <a @click="setPage(page + 1)"><i class="fa fa-angle-right"></i></a>
    </li>
    <li class="right-arrow seta-final" :class="{'disabled': page === countPage}">
      <a @click="setPage(countPage)"><i class="fa fa-angle-double-right"></i></a>
    </li>
  </ul>
</div>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// indice.vue?8c6d8cc0